import { ErrorLike } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

import { Kitchen } from '../libs';
import { TRACEABILITY_SCAN_LABEL_MUTATION } from '../libs/graphQL/traceability';
import { ScanLabelInput, ScanResult } from '../views/Traceability/types';

/** Nothing pushes handheld changes to the web, so a registering scan reloads the label queries on screen. */
const REFETCHED_QUERIES = ['TraceabilityLabels', 'TraceabilityChildLabels', 'TraceabilityLabel'];

/** Sends the label and the kitchen only: the server takes the caller from the identity. A later scan of a label only reads it. */
export interface UseScanLabelResult {
  scanLabel: (args: Omit<ScanLabelInput, 'kitchen'>) => Promise<ScanResult>;
  loading: boolean;
  error: ErrorLike | undefined;
}

export const useScanLabel = (kitchen: Kitchen): UseScanLabelResult => {
  const [mutate, { loading, error }] = useMutation<{ scanLabel: ScanResult }>(TRACEABILITY_SCAN_LABEL_MUTATION, {
    refetchQueries: ({ data }) => (data?.scanLabel.registered ? REFETCHED_QUERIES : [])
  });

  const scanLabel = async (args: Omit<ScanLabelInput, 'kitchen'>): Promise<ScanResult> => {
    const { data } = await mutate({ variables: { input: { ...args, kitchen } } });
    return data!.scanLabel;
  };
  return { scanLabel, loading, error };
};
